import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { loginActivateGuard } from './service/login.guard';
import { AccountSelectionResolver } from './service/account-selection.resolver';
import { authLoadGuard } from './service/auth.guard';
import { AccountSelectedGuard } from './service/account-selected.guard';
import { adminOrGroupUserLoadGuard } from './service/admin-or-group-user.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginActivateGuard],
  },
  {
    path: 'report',
    data: { animation: 'Report' },
    loadChildren: () =>
      import('./modules/report/report.module').then((m) => m.ReportModule),
    canLoad: [authLoadGuard],
  },
  {
    path: 'statements',
    data: { animation: 'Statements' },
    loadChildren: () =>
      import('./modules/statements/statements.module').then(
        (m) => m.StatementsModule,
      ),
    canLoad: [authLoadGuard, AccountSelectedGuard],
  },
  {
    path: 'account-information',
    data: { animation: 'AccountInformation' },
    loadChildren: () =>
      import('./modules/account-information/account-information.module').then(
        (m) => m.AccountInformationModule,
      ),
    canLoad: [authLoadGuard, AccountSelectedGuard],
  },
  {
    path: 'account-selection',
    data: { animation: 'AccountSelection' },
    loadChildren: () =>
      import('./modules/account-selection/account-selection.module').then(
        (m) => m.AccountSelectionModule,
      ),
    canLoad: [authLoadGuard, adminOrGroupUserLoadGuard],
    resolve: {
      preload: AccountSelectionResolver,
    },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
